import React from "react";

const CollapseBody = (props) => {
  return <div>{props.children}</div>;
};

export default CollapseBody;
